export const AGE_OPTIONS = [
  { value: 'age_18_20', label: 'feature.card_form_request.options.age.18_20' },
  { value: 'age_21_40', label: 'feature.card_form_request.options.age.21_40' },
  { value: 'age_41_65', label: 'feature.card_form_request.options.age.41_65' },
  { value: 'age_66_plus', label: 'feature.card_form_request.options.age.66_plus' }
]

export const WORKPLACE_OPTIONS = [
  { value: 'private', label: 'feature.card_form_request.options.workplace.private' },
  { value: 'government', label: 'feature.card_form_request.options.workplace.government' },
  { value: 'entrepreneur', label: 'feature.card_form_request.options.workplace.entrepreneur' },
  { value: 'unemployed', label: 'feature.card_form_request.options.workplace.unemployed' },
  { value: 'other', label: 'feature.card_form_request.options.workplace.other' }
]

export const APP_OPTIONS = [
  { value: 'used_before', label: 'feature.card_form_request.options.app.used_before' },
  { value: 'receive_salary', label: 'feature.card_form_request.options.app.receive_salary' },
  { value: 'using', label: 'feature.card_form_request.options.app.using' },
  { value: 'not_using', label: 'feature.card_form_request.options.app.not_using' }
]

export const APP_NAME = 'Bakai24'
